var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSync = function SvgSync(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.75 8.25H3V4.5M21 12a9 9 0 0 0-9-9C8.37 3 5.249 5.154 3.826 8.25m13.424 7.5H21v3.75M3 12a9 9 0 0 0 9 9c3.63 0 6.751-2.154 8.174-5.25"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSync);
export default ForwardRef;